module.exports = __webpack_public_path__ + "img/location-and-map---location-pin-1@2x.7225fac2.png";